<template>
    <section>
        <v-row>
            <v-col cols="12">  
                <div style="position:relative">
                    <v-data-table
                    :headers="headers"
                    :items="items"
                    :server-items-length="total"
                    :loading="loading"
                    :footer-props="tableFooter"
                    :options.sync="options"
                    class="mt-16"
                    locale="pt-pt"
                    >
                    
                        <template v-slot:item.day="{item}">
                            {{getDayType(item)}}
                        </template>

                        <template v-slot:item.actions="{item}">
                
                            <IconRemove
                                class="mr-2"
                                v-if="$store.getters.hasPermission(['super'])"
                                @on-submit="deleteJob(item)"
                            />
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                Criar novos jobs
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="7">   
                <v-text-field
                    v-model="fields.type"
                    dense outlined
                    label="Referência"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-menu
                    ref="menu"
                    v-model="hourMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="fields.hour"
                            label="Hora"
                            readonly
                            dense
                            outlined
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        v-model="fields.hour"
                        format="24hr"
                        @change="hourMenu = false"
                    ></v-time-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="3">
                <v-autocomplete
                    v-model="fields.day"
                    :items="days"
                    item-value="type"
                    item-text="text"
                    dense outlined
                    label="Dia"
                />
            </v-col>
            <v-col cols="12" md="3" v-if="fields.day == '8'">
                <v-text-field
                    v-model="fields.value"
                    label="Em que dia?"
                    dense
                    outlined
                    type="number"
                    min="1"
                    max="31"
                    hint="Dia do mês"
                    persistent-hint
                />
            </v-col>
            <v-col cols="12" md="12">   
                <v-textarea
                    v-model="fields.task"
                    dense outlined
                    label="Descrição"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn class="success" @click="submit">
                    Gravar
                </v-btn>
            </v-col>
        </v-row>
        
    </section>
  </template>
  <script>
  import IconRemove from '@/components/UI/IconRemove.vue';
  import JobsPlanner from "@/api/JobsPlanner.js";
  //import dayjs from 'dayjs';

  export default {
    components: {
        IconRemove
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchJobs()}, 10);
        },
        deep: true,
      },
    },
    beforeCreate(){
      document.title = "GPD - Gestão de jobs";
    },
    data: () => ({
        days:[
            {
                type: '0',
                text: 'Domingo',
            },
            {
                type: '1',
                text: 'Segunda-feira',
            },
            {
                type: '2',
                text: 'Terça-feira',
            },
            {
                type: '3',
                text: 'Quarta-feira',
            },
            {
                type: '4',
                text: 'Quinta-feira',
            },
            {
                type: '5',
                text: 'Sexta-feira',
            },
            {
                type: '6',
                text: 'Sábado',
            },
            {
                type: '7',
                text: 'Todos os dias',
            },
            {
                type: '8',
                text: 'Mensalmente',
            }
        ],
        hourMenu: false,
        fields:{
            task: null,
            type: null,
            hour: null,
            day: null,
            value: null,
            is_active: true,
            reference: null
        },
        headers: [
            { 
                text: 'Tarefa', 
                value: 'task', 
                sortable: false 
            },
            { 
                text: 'Tipo', 
                value: 'type', 
                sortable: false 
            },
            { 
                text: 'Hora', 
                value: 'hour', 
                sortable: false 
            },
            { 
                text: 'Dia', 
                value: 'day', 
                sortable: false 
            },
            { 
                text: 'Última exec.', 
                value: 'last_ran_at', 
                sortable: false 
            },
            { 
                text: 'Opções', 
                value: 'actions', 
                sortable: false 
            },
        ],
        items: [],
        total: 0,
        loading: false,
        searching: false,
        tableFooter: {
            'items-per-page-options': [5, 10, 15, 20],
            'items-per-page-text': "Linhas por página"
        },
        options: {},
        speedDial:false,
        filter: {
            
        },
        classific: [],
    }),
    mounted(){
      if(!this.$store.getters.hasPermission(["super"])){
        this.$router.push('/no-permission');
      }
  
      this.fillBaseData();
    },
    methods:{
        getDayType(item){
            let f = '-'
            this.days.forEach(element => {
                if(parseInt(element.type) === parseInt(item.day))
                    f = element.text
            });

            return f
        },
        deleteJob(item){
            console.log('ID do job a apagar:', item.id)
            JobsPlanner.delete(item.id).then(() => {
                this.searchJobs()
            })
        },
        submit(){
            JobsPlanner.create(this.fields).then(() =>  {
                this.searchJobs()
            })
        },
        fillBaseData() {
    
            if(localStorage["jobs-planner-" + this.$store.getters.id] != undefined){
    
            let data = JSON.parse(localStorage["jobs-planner-" + this.$store.getters.id]);
    
            this.filter = data.filter;
    
            this.options = data.options;
            }

            this.searchJobs()

        },
        searchJobs(event){
            if(!!event && event.type == 'submit'){
            this.options.page = 1;
            }
    
            this.loading = true;
    
            let filter = {...this.filter};

            let request = {
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
            page: this.options.page,
            limit: this.options.itemsPerPage,
            };
        
            Object.assign(request, filter);

            localStorage["jobs-planner-" + this.$store.getters.id] = JSON.stringify({
            filter: this.filter,
            options: this.options,
            });
    
            JobsPlanner.search(request).then(response => {
    
            let data = response.data;
    
            this.total = data.total;
    
            this.items = data.data.map((item) => {
    
                this.searching = false;
    
                return item;
            });
    
            this.loading = false;
    
            });
        },
        resetJobsPlanner()
        {
            this.filter = {
            };
    
            this.searchJobs();
        },
    },
    computed: {
      
    }
  };
  </script>
  